import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import { getLanguage, setLanguage, initTranslations } from "./core/i18n";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

// Fetch dynamic translations on app start
initTranslations().catch(console.error);

// Apply stored language to document root so initial render can use it
try {
  // Check raw stored value to migrate legacy stored labels (if any)
  const rawLang = typeof localStorage !== "undefined" ? localStorage.getItem("app_language") : null;
  let lang = getLanguage();
  if (rawLang === "English") {
    lang = "en";
    setLanguage("en");
  } else if (rawLang === "Hindi") {
    lang = "hi";
    setLanguage("hi");
  }
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-lang", lang);
  }
} catch (e) {
  // ignore
}

// Auto-migrate old global loader setting
if (localStorage.getItem("dataLoader") === "enable") {
  localStorage.setItem("dataLoader", "disable");
  console.log("✅ Auto-migrated: Global loader disabled, using component-level loading");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <ALLRoutes />
      </BrowserRouter>
    </Provider>
  </>
);
